import { Component, Input } from '@angular/core';
import { GlobalConstants } from 'src/app/services/global-constants';

@Component({
  selector: 'app-eservicepanelview',
  templateUrl: './eservicepanelview.component.html',
  styleUrls: ['./eservicepanelview.component.scss']
})
export class EservicepanelviewComponent {

  @Input() data: any;
  @Input() item: any;

  staticURL = GlobalConstants.staticFilesURL;


  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

}
